import React from 'react';

export default function ConfirmModal({ title, message, confirmLabel = 'Confirmer', onConfirm, onCancel }) {
  return (
    <div
      onClick={onCancel}
      style={{
        position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.45)', zIndex: 1000,
        display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '1.5rem'
      }}
    >
      <div
        onClick={e => e.stopPropagation()}
        className="party-card p-4"
        style={{ maxWidth: 340, width: '100%', textAlign: 'center' }}
      >
        <div style={{ fontSize: '2.2rem', marginBottom: '0.5rem' }}>⚠️</div>
        <h3 style={{ fontWeight: 800, color: '#1a2e35', fontSize: '1.15rem', marginBottom: '0.4rem' }}>{title}</h3>
        <p style={{ color: '#607d8b', fontSize: '0.9rem', marginBottom: '1.5rem' }}>{message}</p>
        <div style={{ display: 'flex', gap: '0.6rem' }}>
          <button
            onClick={onCancel}
            className="btn"
            style={{ flex: 1, borderRadius: '50px', fontWeight: 700, background: '#eceff1', color: '#455a64', border: 'none', padding: '0.7rem' }}
          >
            Annuler
          </button>
          <button
            onClick={onConfirm}
            className="btn"
            style={{ flex: 1, borderRadius: '50px', fontWeight: 700, background: '#dc3545', color: '#fff', border: 'none', padding: '0.7rem' }}
          >
            {confirmLabel}
          </button>
        </div>
      </div>
    </div>
  );
}
